    
<template>
    <div class="container">
        <div class="d-flex flex-column flex-root" id="kt_app_root">
			<!--begin::Page bg image-->
			<!--end::Page bg image-->
			<!--begin::Authentication - Signup Welcome Message -->
			<div class="d-flex flex-column flex-center flex-column-fluid">
				<!--begin::Content-->
				<div class="d-flex flex-column flex-center text-center p-10">
					<!--begin::Wrapper-->
					<div class="card card-flush w-lg-650px py-5">
						<div class="card-body py-15 py-lg-20">
							<h1 class="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
							<div class="fw-semibold fs-6 text-gray-500 mb-7">Pagina nu a fost gasita !</div>
							<div class="mb-3">
								<img :src="imgLight" class="mw-100 mh-300px theme-light-show" alt="" />
								<img :src="imgDark" class="mw-100 mh-300px theme-dark-show" alt="" />
							</div>
							<div class="mb-0">
								<a href="https://artprime.ro" class="btn btn-sm btn-primary text-hover-white" style="cursor: pointer;">{{ $t("navigare.acasa") }}</a>
                                <a class="btn btn-sm btn-primary text-hover-white" @click="$router.go(-1)" style="cursor: pointer;">{{ $t("butoane.buton_inapoi") }}</a>
							</div>
							<!--end::Link-->
						</div>
					</div>
					<!--end::Wrapper-->
				</div>
				<!--end::Content-->
			</div>
			<!--end::Authentication - Signup Welcome Message-->
		</div>
    </div>
</template>

<script>

import imgLight from '~/tema/src/media/auth/404-error.png'
import imgDark from '~/tema/src/media/auth/404-error-dark.png'

    export default {
        mounted() {
           
        }
    }
</script>


<style lang="scss" scoped>


</style>
    